import axios from 'axios';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import DefaultLoader from '../loader/DefaultLoader';
import {useCookies} from 'react-cookie';
import PlayerSlide from '../slide/PlayerSlide';
import dateSetting from '../../utils/dateSetting';
import { useTranslation } from 'react-i18next';

function SeriesBatterList({teamObj, title, checked, profile}) {
    const [cookies] = useCookies(['hiball_token']);
    let [batterArr, setBatterArr] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        let dateObj = dateSetting();
        let params = {
            recordType: 'digestBattingRecord', recordName: 'selectMaxTpaPlayer',
            batterTeamIds: teamObj['teamId'],
            seasons: [dateObj['season'], dateObj['season']-1].toString(),
            gameTypeCode: 4201,
            authToken:JSON.stringify(cookies['hiball_token'])
        }

        if(checked) {
            params['pitcherIds'] = profile['playerId'];
        }

        axios({
            url : `${process.env.REACT_APP_API_URL}`, params
        }).then((result) => {
            let matchBatter = result['data']['result'];
            let sortBatter = _.sortBy(matchBatter, (item) => {
                return item['tpa'];
            }).reverse();

            setBatterArr(sortBatter);
        });
    }, [teamObj, checked]);

    if(teamObj['teamId'] === 0 || batterArr.length === 0) {
        return (
            <>
                <div className="starter">
                <div className="listTitle">
                    <hr/>{title}<hr/>
                </div>
                <div className="imageWrap" style={{height:'126px', justifyContent: 'center'}}>
                    <div>No Data</div>
                </div>
                </div>
            </>
        )
    }

    return (
    <>
        <div className="starter">
            <div className="listTitle">
                <hr/>{t('keyHitters')}<hr/>
            </div>
            <PlayerSlide data={batterArr} position={"batter"} checked={checked} profile={profile}/>
        </div>
    </>
    )
}

export default SeriesBatterList;